import { Component, OnInit, ViewChild, QueryList, ElementRef, ViewChildren, AfterViewInit, ChangeDetectorRef, ViewRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as Rx from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import * as UserDataConfig from '../../../../pages/user-details/config/user-data.config';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { SyncService } from '../../services/sync.service';
import { LifeStyleQuestion, Sections, HealthLifestyle, rangeData } from '../../model/lifestyle.model';
import { UnderWritingData, QuestionsToAPI, AnnuitantMedicalConditions, RiskWarningModel } from '../../model/lifestyle.post.model';
import * as LifeStyleActions from '../../store/actions/lifestyle.action';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { UtilityServiceForMedicalService } from '../../services/utility-service';
// tslint:disable-next-line:max-line-length
import { YourOptionsQuestionsComponent } from 'src/app/pages/user-details/components/your-options-questions/your-options-questions.component';
import { QuoteDataCaptureService, FormValidationsService, UtilService, LoaderService, SERVICE_END_POINT, AnalyticsService, AuthService } from '../../../../shared';
import { QuestionComponent } from 'src/app/common-components/question/question.component';
import { Observable, Subscription } from 'rxjs';
import { InputComponent } from 'src/app/common-components/input/input.component';
import { Tooltip } from 'src/app/model/tooltip';
import { Question } from 'src/app/model/question';
import { RadioButton } from 'src/app/model/radio-button/radio-button';
import { MandatoryQuestionsDirective } from '../../directives/mandatory-questions-directive';
import { OnlyNumberModule } from '../../directives/custom-onlyNumber-directive';
import { ControlTypesComponent } from '../control-types/control-types.component';
import { AdItem } from '../ad-item.component';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';
// import { FormValidationsService, QuoteDataCaptureService, ModalScroll } from '../../../../shared';

import { PersonalDetails, RefNo } from 'src/app/model/ngrx';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { InvalidCtlNameObj } from '../../model/mcUserJourney.model';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-lifestyle',
  templateUrl: './lifestyle-new.component.html',
  styleUrls: ['./lifestyle-new.component.scss']
})
export class LifestyleNewComponent implements OnInit, AfterViewInit {

  public healthData: any;
  public CMSData: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public lifestyleForm: UntypedFormGroup;
  public lifestyleFormForRisk: UntypedFormGroup;
  private sectionsList: Sections[] = [];
  private questionToDisplayForDCJLS: LifeStyleQuestion[];
  private rangeValidationData: any;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  public lifestyleConfig: Tooltip;

  private lifeStylePayload: QuestionsToAPI[];

  private underWritingData: UnderWritingData;
  private lifeStylePayloadFromStore: UnderWritingData;
  private jsonObj: HealthLifestyle;
  allowStoresubscribe: boolean;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  public componentRefOfControlType: ComponentRef<ControlTypesComponent>;
  private subscripLogout: Subscription;
  private invalidDataSubscription: Subscription;
  public loadSpinner: boolean;
  personalDetailsData: Observable<PersonalDetails[]>;
  referenceNumberStore: Observable<RefNo[]>;
  isHOView = false;
  backButtonEnabled = true;
  personDetail: PersonalDetails;
  private indexToSearchFromStore: number;
  quoteRefNumber = '';
  referenceNumber: RefNo;
  editMode: boolean;
  subscription: any;
  screenName: string;
  displayTooltipAlert = false;
  questionListSubject: BehaviorSubject<LifeStyleQuestion[]> = new BehaviorSubject([]);

  @ViewChild(MandatoryQuestionsDirective, { static: true }) mandatoryQuestionsDir: MandatoryQuestionsDirective;


  constructor(private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public el: ElementRef,
    private healthService: HealthService,
    private syncService: SyncService,
    public utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private store: Store<AppState>,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private utilService: UtilService,
    private cdRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private loaderService: LoaderService,
    private analyticsService: AnalyticsService, private authService: AuthService) {
    this.personalDetailsData = store.select(STORE_VAL.personal_details);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    // console.log('consol for HO ->', this.router.url);
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
    this.backButtonEnabled = this.router.url.includes('ho-underwriting/lifestyle') ? false : true;
    this.personalDetailsData.subscribe((val) => {
      if (val.length > 0) {
        //console.log('call personalDetailsData subscribe');
        this.personDetail = val[0];
        //console.log('call personDetail subscribe', this.personDetail.dateOfBirth);
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        // this.quoteRefNo = val[0]['quoteReferenceNumber'];
        //console.log("refrence number is", this.referenceNumber);
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          // this.personalFormEdit = JSON.parse(JSON.stringify(this.personDetail));
        } else {
          this.editMode = false;
        }
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    // tslint:disable-next-line: max-line-length
    this.quoteRefNumber = this.activatedRoute.snapshot.queryParamMap.get('quoteRefNo') ? this.activatedRoute.snapshot.queryParamMap.get('quoteRefNo') : null;
    //console.log('Utility service Dependant check->', this.utilityServiceForMedicalService.currentUWScreenName);
    this.healthData = this.activatedRoute.snapshot.data.contentData.healthandlifestyle;
    this.InitializeToolTipForHeader();
    this.setLifestyleForm();

    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });

    this.invalidDataSubscription = this.utilService.invalidDataEvt.subscribe((invalidObj: InvalidCtlNameObj) => {
      this.handleInvalidData(invalidObj);
    });

    if (this.quoteRefNumber && this.quoteRefNumber.length > 1) {
      this.ResumeQuote(this.quoteRefNumber);
    }

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      this.healthData.header = this.healthData.dependantHeader;
    } else {
      this.healthData.header = this.healthData.header;
    }
    this.subscription = this.utilService.resetEditMode.subscribe(res =>
      this.resetEditmode());
  }

  ngAfterViewInit() {
    this.getLifestyleRange();
    this.getLifestyleData();

  }

  emitSaveCompModalEvent() {
    // need to write logic for stopping modal
  }

  setLifestyleForm = () => {
    this.lifestyleForm = this.fb.group({

    });
  }

  setLifestyleRiskWarningForm() {
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && !this.isHOView && !this.lifestyleFormForRisk) {
      this.lifestyleFormForRisk = this.fb.group({
        lifestyleRiskWarningQuestion: ['', Validators.required]
      });
    }
  }

  setValueLifestyleRiskWarningForm() {
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && !this.isHOView && this.lifestyleFormForRisk) {
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.riskAndStaticQuestion && this.lifeStylePayloadFromStore.riskAndStaticQuestion.answer) {
        this.lifestyleFormForRisk.controls['lifestyleRiskWarningQuestion'].setValue(this.lifeStylePayloadFromStore.riskAndStaticQuestion.answer);
      }
      else {
        this.lifestyleFormForRisk.controls['lifestyleRiskWarningQuestion'].setValue(null);
      }
    }
  }

  saveAfterLogin() {
    this.lifeStylePayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
    this.emitSaveCompModalEvent();
  }
  saveAfterLogout() {
    this.lifeStylePayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
    this.emitSaveCompModalEvent();
  }
  saveProgress() {
    this.lifeStylePayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
    this.emitSaveCompModalEvent();
  }

  handleInvalidData(invalidObj: InvalidCtlNameObj) {
    if (invalidObj && invalidObj.invalidDataPresent) {
      this.componentRefOfControlType.instance.throwValidationForOneCtl(this.lifestyleForm, invalidObj.ctlName);
    }
  }

  /* checkIfAnyInvalidDataPresent(): boolean {
    let invalidDataPresent = false;
    let obj: InvalidCtlNameObj = this.utilityServiceForMedicalService.isInvalidDataFoundInForm(this.lifestyleForm);
    if (obj && obj.invalidDataPresent) {
      invalidDataPresent = obj.invalidDataPresent;
      this.componentRefOfControlType.instance.throwValidationForOneCtl(this.lifestyleForm, obj.ctlName);
    } else {
      invalidDataPresent = false;
    }
    return invalidDataPresent;
  } */

  InitializeToolTipForHeader() {
    this.lifestyleConfig = new Tooltip(this.healthData.infoText, '', false);
  }

  getLifestyleData() {
    this.healthService.getHealthContent()
      .subscribe(res => {

        const questionToDisplayObj: LifeStyleQuestion[] = [];
        this.jsonObj = res;
        this.sectionsList = this.jsonObj.section;
        this.syncService.setMedicalConditionJson(this.sectionsList);
        this.sectionsList.forEach(sec => {
          const temp = sec.question.filter(res => res.dcjCustomerDisplay === 'Yes' && res.mandatoryInitialDisplay === 'Yes');
          temp.forEach(ques => {
            ques.sectionNameToRefer = sec.sectionName;
            questionToDisplayObj.push(ques);
          });
        });
        this.questionToDisplayForDCJLS = questionToDisplayObj;
        this.allowStoresubscribe = true;
        this.getQuestionToDisplayForDCJLS();
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      });
  }
  getLifestyleRange() {
    this.healthService.getRangeValidation()
      .subscribe(res => {
        this.rangeValidationData = res.values;
        this.syncService.setRangeValidationJson(this.rangeValidationData);
      });
  }

  getQuestionToDisplayForDCJLS() {

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      this.setLifestyleRiskWarningForm();
      if (this.allowStoresubscribe) {
        if (res.length > 0) {
          this.lifeStylePayloadFromStore = res[0];
          this.setValueLifestyleRiskWarningForm();
          // tslint:disable-next-line: max-line-length
          if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && this.lifeStylePayloadFromStore.annuitantMedicalConditions
            && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0)) {
            this.lifeStylePayloadFromStore.annuitantMedicalConditions.forEach(element => {
              if (element.questionSetName === this.jsonObj.questionSetName) {
                this.indexToSearchFromStore = element.index;
              }
            });
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForDCJLS);
          } else if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant' && this.lifeStylePayloadFromStore.dependentMedicalConditions
            && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0)) {
            this.lifeStylePayloadFromStore.dependentMedicalConditions.forEach(element => {
              if (element.questionSetName === this.jsonObj.questionSetName) {
                this.indexToSearchFromStore = element.index;
              }
            });
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForDCJLS);
          } else {
            // this.renderUIWithDefaultValues();
            this.renderUIWithDefaultValues();
            this.loadComponent(this.questionToDisplayForDCJLS);
          }

        } else {
          this.renderUIWithDefaultValues();
          this.loadComponent(this.questionToDisplayForDCJLS);
        }
      }
    });

  }

  renderUIWithDefaultValues() {
  }

  renderUIBasedOnSelectedresponseValue() {
    this.addResponseValueByUserToQuestionsList();

    // TODO: partial - quotes- go through json again whre next step values found and trigger the user action function();

  }



  getAnswerFromStore(questionId: string): QuestionsToAPI {
    let value: QuestionsToAPI;
    value = this.utilityServiceForMedicalService.getResponseValuesFromStore(questionId, this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
    return value;
  }

  addResponseValueByUserToQuestionsList() {
    this.sectionsList.forEach(sec => {
      sec.question.forEach(qus => {
        const temp = this.getAnswerFromStore(qus.id);
        qus.responseValueByUser = temp ? temp.responseValue : undefined;
        // qus.defaultResponseValue = qus.responseValueByUser;
      });

    });
  }

  loadComponent(questionList: LifeStyleQuestion[]) {
    const adItem = new AdItem(ControlTypesComponent, {});
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(adItem.component);
    const viewContainerRef = this.mandatoryQuestionsDir.viewContainerRef;
    viewContainerRef.clear();
    this.componentRefOfControlType = viewContainerRef.createComponent(ControlTypesComponent);
    this.componentRefOfControlType.instance.controlTypeQuestionList = questionList;
    this.componentRefOfControlType.instance.lifeStylePayloadFromStoreObj = this.lifeStylePayloadFromStore;
    this.componentRefOfControlType.instance.parentForm = this.lifestyleForm;
    this.componentRefOfControlType.instance.errorValue = [{ isValid: false, errorMessage: '', questionId: null }];
    this.componentRefOfControlType.instance.indexStoredInUWDataObj = this.indexToSearchFromStore;
    let obj = new ParentFormAndElmModel(this.componentRefOfControlType.instance.parentForm, this.el,
      this.componentRefOfControlType.instance.cdRef, this.lifestyleFormForRisk);
    obj.emitInvalidEvtFlag = true;
    this.utilService.setParentFormToValidate(obj);
  }

  createRiskWarning(fromForm: boolean) { // this should be called only in annuitant 
    let riskWarning: RiskWarningModel = new RiskWarningModel();
    riskWarning.questionCode = 'lifestyleRiskWarningQuestion';
    riskWarning.questionType = this.healthData.yourLifestyleConfig.questionType;
    if (fromForm) {
      riskWarning.answer = this.getRiskWarningFromForm();
    }
    else {
      riskWarning.answer = this.getRiskWarningFromStore();
    }
    return riskWarning;
  }

  getRiskWarningFromForm(): string {
    return this.lifestyleFormForRisk.controls['lifestyleRiskWarningQuestion'] ? this.lifestyleFormForRisk.controls['lifestyleRiskWarningQuestion'].value : null;
  }

  getRiskWarningFromStore(): string {
    if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.riskAndStaticQuestion && this.lifeStylePayloadFromStore.riskAndStaticQuestion.answer) {
      return this.lifeStylePayloadFromStore.riskAndStaticQuestion.answer;
    }
    else {
      return null;
    }

  }

  lifestyleHealthRiskInfoEmitter(value: string) {
    if (value) {
      this.analyticsService.eventTrack({ type: 'Question', name: value, pageID: this.getCurrentScreenURL() });
    }
  }

  lifestylePrivacyInfo() {
    this.analyticsService.eventTrack({ type: 'LinkClick', name: 'Privacy policy', pageID: this.getCurrentScreenURL() })
  }

  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

  saveFormValues() {
    //console.log(this.lifeStylePayload);
    this.underWritingData = new UnderWritingData();
    // tslint:disable-next-line:max-line-length
    this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.annuitantMedicalConditions ? this.lifeStylePayloadFromStore.annuitantMedicalConditions : [];
    // tslint:disable-next-line:max-line-length
    this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.dependentMedicalConditions ? this.lifeStylePayloadFromStore.dependentMedicalConditions : [];
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
      if (!this.isHOView) {
        this.underWritingData.riskAndStaticQuestion = this.createRiskWarning(true);
        this.underWritingData.lifeStyleRiskWarning = this.getRiskWarningFromForm();
      }
      let tempAnnuitantLifestyle = [];
      //tempAnnuitantLifestyle = [...this.lifeStylePayloadFromStore.annuitantMedicalConditions];
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.annuitantMedicalConditions
        && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0) {
          this.lifeStylePayloadFromStore.annuitantMedicalConditions.forEach((element, index) => {
          if (element.index === this.indexToSearchFromStore) {
            element = { ...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload) };
            element = { ...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload) };
            //element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload);
            //element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload);
            // console.log("Check:::::" + element.status);
            // console.log(element.questions);
            //this.lifeStylePayloadFromStore.annuitantMedicalConditions[index] = element;
            this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, annuitantMedicalConditions:[...this.lifeStylePayloadFromStore.annuitantMedicalConditions.slice(0,index),element, ...this.lifeStylePayloadFromStore.annuitantMedicalConditions.slice(index+1,this.lifeStylePayloadFromStore.annuitantMedicalConditions.length)]}
          }
        });
        //this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, annuitantMedicalConditions: this.lifeStylePayloadFromStore.annuitantMedicalConditions};
        this.underWritingData = {...this.underWritingData, annuitantMedicalConditions: this.lifeStylePayloadFromStore.annuitantMedicalConditions};
        //this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions;
      } else {
        let tempAnnuitantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
        // tempAnnuitantMed.questionSetName = this.jsonObj.questionSetName;
        // tempAnnuitantMed.index = 0;
        // tempAnnuitantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload);
        // tempAnnuitantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload);
        tempAnnuitantMed = { ...tempAnnuitantMed, questionSetName: this.jsonObj.questionSetName };
        tempAnnuitantMed = { ...tempAnnuitantMed, index: 0 };
        tempAnnuitantMed = { ...tempAnnuitantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload) };
        tempAnnuitantMed = { ...tempAnnuitantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload) };

        // console.log("Check:::::" + tempAnnuitantMed.status);
        // console.log(tempAnnuitantMed.questions);
        //this.underWritingData.annuitantMedicalConditions.push(tempAnnuitantMed);
        this.underWritingData = {...this.underWritingData, annuitantMedicalConditions: [...this.underWritingData.annuitantMedicalConditions,tempAnnuitantMed]};
        this.lifeStylePayloadFromStore = this.underWritingData;
      }
    }
    else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      if (this.lifeStylePayloadFromStore) {
        this.underWritingData.riskAndStaticQuestion = this.createRiskWarning(false);
        this.underWritingData.lifeStyleRiskWarning = this.getRiskWarningFromStore();
      }
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.dependentMedicalConditions
        && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0) {
        this.lifeStylePayloadFromStore.dependentMedicalConditions.forEach((element, index) => {
          if (element.index === this.indexToSearchFromStore) {
            element = { ...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload) };
            element = { ...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload) };
            //element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload);
            //element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload);
            //this.lifeStylePayloadFromStore.dependentMedicalConditions[index] = element;
            this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, dependentMedicalConditions:[...this.lifeStylePayloadFromStore.dependentMedicalConditions.slice(0,index),element, ...this.lifeStylePayloadFromStore.dependentMedicalConditions.slice(index+1,this.lifeStylePayloadFromStore.dependentMedicalConditions.length)]}
          }
        });
        this.underWritingData = {...this.underWritingData, dependentMedicalConditions: this.lifeStylePayloadFromStore.dependentMedicalConditions};
      } else {
        let tempDependantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
        // tempDependantMed.questionSetName = this.jsonObj.questionSetName;
        // tempDependantMed.index = 0;
        // tempDependantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload);
        // tempDependantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload);

        tempDependantMed = { ...tempDependantMed, questionSetName: this.jsonObj.questionSetName };
        tempDependantMed = { ...tempDependantMed, index: 0 };
        tempDependantMed = { ...tempDependantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.lifeStylePayload) };
        tempDependantMed = { ...tempDependantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.lifeStylePayload) };
        console.log('----------1--------------',this.underWritingData);
        this.underWritingData = {...this.underWritingData, dependentMedicalConditions: [...this.underWritingData.dependentMedicalConditions,tempDependantMed]};
        console.log('----------2--------------',this.underWritingData);
        //this.underWritingData.dependentMedicalConditions.push(tempDependantMed);
        this.lifeStylePayloadFromStore = this.underWritingData;
      }
    }
    if (this.underWritingData && this.underWritingData.annuitantMedicalConditions && this.underWritingData.annuitantMedicalConditions.length > 0) {
      this.underWritingData = { ...this.underWritingData, annuitantMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.underWritingData.annuitantMedicalConditions) }

    }
    if (this.underWritingData && this.underWritingData.dependentMedicalConditions && this.underWritingData.dependentMedicalConditions.length > 0) {
      this.underWritingData = { ...this.underWritingData, dependentMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.underWritingData.dependentMedicalConditions) }

    }
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new LifeStyleActions.AddLifestyleResult(this.underWritingData));

  }

  showLoader() {
    this.loadSpinner = true;
    this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: true, Message: '', opacity: .4 });
  }

  hideLoader() {
    this.loadSpinner = false;
    this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
  }


  triggerPostQuotesAPI(isbackBtnClicked: boolean) {
    this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
      this.hideLoader();
      if (isbackBtnClicked) {
        if (this.isHOView) {
          this.router.navigate([MEDICAL_UW_HO_URL.annuitant.doctorDetails]);
        } else {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL('/home/your-product-choice', '/home/your-dependant')]);
        }
      } else {
        if (this.isHOView) {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
        } else {
          // this.router.navigate([MEDICAL_UW_URL.annuitant.AMC]);
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
          // this.router.navigate(['/home/your-dependant']);
        }
      }
    },
      err => {
        this.hideLoader();
      });
  }

  preparePayload(isbackBtnClicked: boolean) {
    this.saveFormValues();
    this.triggerPostQuotesAPI(isbackBtnClicked);
  }

  removeUnwantedFormBasedOnPayload() {
    let quesIdListToSend: string[];
    quesIdListToSend = this.utilityServiceForMedicalService.getQuesIdListToSend(this.lifeStylePayload, null);
    this.utilityServiceForMedicalService.removeUnwantedFormControl(quesIdListToSend, null, this.lifestyleForm);
    this.syncService.emitEventForBusinessValidation(null);
  }

  extractFromFormObjAndPrepareBackendJson() {
    this.lifeStylePayload = [];
    this.questionToDisplayForDCJLS.forEach(mandatoryQuesObj => {
      const backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, mandatoryQuesObj, null);
      if (mandatoryQuesObj.controlType && mandatoryQuesObj.controlType.toLowerCase() !== 'textonly') {
        this.lifeStylePayload.push(backendQuestionObjForMandatoryQues);
      }
      const selectedValueForMandatoryQues = backendQuestionObjForMandatoryQues.responseValue;
      this.recursiveFunForDependentQuestion(selectedValueForMandatoryQues, mandatoryQuesObj);
    });
    this.removeUnwantedFormBasedOnPayload();
  }

  recursiveFunForDependentQuestion(selectedValueForMandatoryQues: any, quesObj: LifeStyleQuestion) {
    if (typeof selectedValueForMandatoryQues === 'string' && selectedValueForMandatoryQues && quesObj.responseValue && quesObj.responseValue.length > 0) {
      // for the values where response value can be one. like input , number, radiobtn (yes/no)
      this.prepareForDepQuestionsForResValueAsString(quesObj, selectedValueForMandatoryQues);
    }
    if (selectedValueForMandatoryQues === null && quesObj.responseValue === null && quesObj.nextStep && quesObj.nextStep.length > 0) {
      //  for dummy questions but it can contains nextstep questions. eg: grid
      this.prepareForDepQuestionsForResValueAsNull(quesObj);
    }
    /* if (Array.isArray(selectedValue) && mandatoryQuesObj.nextStep && mandatoryQuesObj.nextStep.length > 0) { //  for question which can have dummy questions but it can contains nextstep questions
      this.prepareForDepQuestionsForResValueAsNull(mandatoryQuesObj, payload);
    } */
  }

  prepareForDepQuestionsForResValueAsNull(quesObj: LifeStyleQuestion) {
    const questionIdList: string[] = [];
    if (quesObj.nextStep && quesObj.nextStep.length > 0) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepValue) {
          next.nextStepValue.forEach(id => {
            questionIdList.push(id);
          });
        }
      });
      const nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(questionIdList, null);
      nextQuestionObjList.forEach(nextQuestionObj => {
        const referenceQueId: string = quesObj.id;
        const backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, null);
        if (nextQuestionObj.controlType && nextQuestionObj.controlType.toLowerCase() !== 'textonly') {
          this.lifeStylePayload.push(backendQuestionObjForDependentQues);
        }
        if (backendQuestionObjForDependentQues.responseValue) {
          this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj);
        }
      });
    }
  }

  prepareForDepQuestionsForResValueAsString(quesObj: LifeStyleQuestion, selectedValue: string) {
    const questionIdList: string[] = [];
    if (quesObj.nextStep) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue) {
          const nextQuestionIdList: string[] = next.nextStepValue;
          const nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(nextQuestionIdList, null);
          nextQuestionObjList.forEach(nextQuestionObj => {

            const referenceQueId: string = quesObj.id;
            const backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, null);
            if (nextQuestionObj.controlType && nextQuestionObj.controlType.toLowerCase() !== 'textonly') {
              this.lifeStylePayload.push(backendQuestionObjForDependentQues);
            }
            this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj);
          });
        }
      });
    }

  }


  OnBackClick() {
    this.allowStoresubscribe = false;
    this.lifeStylePayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.preparePayload(true);
  }

  validateAlcoholUnit(): boolean { // "LSQ029","LSQ030","LSQ031", "LSQ032"
    let valid = true;
    let result = this.lifeStylePayload.find(elem => elem.id === "LSQ028");
    if (result) { // means user chose - glasses  alcohol  
      let sum: number = 0;
      let valueToAdd = 0;
      this.lifeStylePayload.forEach(element => {
        if (element.id === "LSQ029"
          || element.id === "LSQ030"
          || element.id === "LSQ031"
          || element.id === "LSQ032") {
          if (element.id === "LSQ030") {
            valueToAdd = element.responseValue ? (Number(element.responseValue) * 2) : 0;
          }
          else {
            valueToAdd = element.responseValue ? Number(element.responseValue) : 0;
          }

          sum = sum + valueToAdd;
        }
      });
      if (sum > 999) {
        valid = false;
      }
      else {
        valid = true;
      }
    }
    else { // means user did not chose - glasses  alcohol  
      valid = true;
    }
    return valid;

  }

  emitAlcoholErrorEvent(validSum: boolean) {
    let obj = { 'questionIdToShowError': "LSQ028", "validSum": validSum };
    let alcoholMaxErrorEvent = new CustomEvent("alcoholMaxErrorEvent", { detail: obj });
    document.dispatchEvent(alcoholMaxErrorEvent);
  }

  markAsTouchedForLsRiskForm() {
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && !this.isHOView && this.lifestyleFormForRisk) {
      this.lifestyleFormForRisk.controls['lifestyleRiskWarningQuestion'].markAsTouched();
    }
  }

  isLSRiskFormValid(): boolean {
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && !this.isHOView && this.lifestyleFormForRisk) {
      return this.lifestyleFormForRisk.valid;
    }
    else { // for dependent we dont have LS RISK question
      return true;
    }
  }

  gotoNextPage = () => {
    this.lifeStylePayload = [];
    this.markAsTouchedForLsRiskForm();
    this.extractFromFormObjAndPrepareBackendJson();
    //console.log(this.lifeStylePayload);
    if (this.componentRefOfControlType.instance.validateForm() && this.isLSRiskFormValid()) { //this.componentRefOfControlType.instance.validateForm()
      if (this.validateAlcoholUnit()) {
        this.emitAlcoholErrorEvent(true);
        this.allowStoresubscribe = false;
        if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
          this.referenceNumber = {...this.referenceNumber, editMode: false};
          this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
          this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
          this.editMode = false;
          this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
        } else {
          this.preparePayload(false);
        }
      }
      else {
        this.emitAlcoholErrorEvent(false);
        this.componentRefOfControlType.instance.throwValidation(this.lifestyleForm);
      }
    }
    else {
      this.componentRefOfControlType.instance.throwValidation(this.lifestyleForm);
      if (!this.isLSRiskFormValid()) {
        this.scrollInvalidForm();
      }
    }

  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  ResumeQuote(quoteRefNo: string) {
    this.quoteDatacaptureService.resumeQuote(quoteRefNo).subscribe(res => {
      this.utilService.restoreAllStore(quoteRefNo, true, false, res, null, true);
    });

  }



  ngOnDestroy() {
    if (this.lifeStyleFromStoreObsSubscription) {
      this.lifeStyleFromStoreObsSubscription.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.invalidDataSubscription) {
      this.invalidDataSubscription.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_Lifestyle;
    //console.log('changed value = ', this.healthData);
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the healthData object values with CMSData object values */
        //this.healthData.header = this.CMSData.string_LifestyleTitle;
        this.healthData.infoText = this.CMSData.string_SubtitleInformationMessage;
        this.lifestyleConfig = new Tooltip(this.healthData.infoText, '', false);
        this.healthData.healthDescriptionText = this.CMSData.string_LifestyleSubtitle;
        this.healthData.privacyPolicyText = this.CMSData.commonBlock.string_PrivacyWording;
        this.healthData.clickHereText = this.CMSData.commonBlock.string_PrivacyPolicyLinkText;
        this.healthData.yourLifestyleConfig.questionStatement = this.CMSData.string_HealthRisksRiskQuestion;
        this.healthData.yourLifestyleConfig.questionOptions.find(res => res['label'] === 'No').infoText
          = this.CMSData.string_HealthRisksRiskQuestionWarningMessage;
        this.healthData.yourLifestyleConfig.questionOptions.find(res => res['label'] === 'Unsure').infoText
          = this.CMSData.string_HealthRisksRiskQuestionWarningMessage;
        // this.dobInformationConfig.content = this.CMSData.string_DOBInformationWording;
        // this.userInputDetail.radioButtonIsUKAddressConfig.infoIconData.content = this.CMSData.string_UKResidencyInformationWording;
        //console.log('changed value = ', this.healthData);
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.healthData.healthDescriptionText =
            this.CMSData.html_LifestyleSubtitleDependant.replace(/<p/gm, '<p class="dependent-subTitle"');
        }

      }
    });
  }
  /** End of code block for CMS */
  resetEditmode = () => {
    if (this.referenceNumber && this.referenceNumber.editMode) {
      this.editMode = false;
      /* Defect# 3345 - Regression - Playback screen - Two pop up appears when clciked on Review
       and also if user clicks on discard chnages then button should be as Done instead of Next */
      /* label name is changed to 'Next' only when formvalues are changed */
      this.userInputDetail['buttonConfig']['label'] = 'Next';
      this.userInputDetail['buttonConfig']['name'] = 'Next';
      this.referenceNumber = {...this.referenceNumber, editMode: false};
      this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
    } else if (this.referenceNumber && this.referenceNumber.isRefreshCard) {
      this.editMode = false;
      /* Defect# 3345 - Regression - Playback screen - Two pop up appears when clciked on Review
       and also if user clicks on discard chnages then button should be as Done instead of Next */
      /* label name is changed to 'Next' only when formvalues are changed */
      this.userInputDetail['buttonConfig']['label'] = 'Next';
      this.userInputDetail['buttonConfig']['name'] = 'Next';
      this.referenceNumber.isRefreshCard = false;
      this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
    }
  }

  displayTooltipMessage(){
    this.tooltipModal.content = this.lifestyleConfig.content;
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
    this.closeModal();
  }

  closeModal() {
    this.displayTooltipAlert = false;
  }
}
